var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser && _vm.currentUser.showId)?_c('div',{class:_vm.$style.devInfo},[_vm._v(" Dev: "),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }